module.exports = __webpack_public_path__ + "img/hohlschnitt_gelb_candy.71759e84.jpg";